import BootslideMenu from '../../components/bootslide/bootslide-menu'
import i18n from '../../components/i18n'
import RestConnectionWizard from 'scoreboard/admin/connections/rest/rest-connection-wizard'
import iconAndLabel from 'scoreboard/components/bootslide/icon-and-label.hbs'
import constants from 'scoreboard/components/constants'
const { WEB_SERVICE, REST } = constants
import Connection, { getDefaultOracleNetSuiteConnection } from 'scoreboard/admin/connections/connection'

const AddWsConnectionMenu = BootslideMenu.extend(/** @lends {AddWsConnectionMenu} */{

	/**
	 * Menu for adding various types of web service connections (see #50596)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 */
	initialize: function(options = {}) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.options = options
		this.allowDynamicWidth = true // Optional
	},

	menu: function() {
		const netSuiteWebServiceLabel = iconAndLabel({
			name: 'webservice',
			label: i18n.get('admin.importConnections.web-service.rest.vendor.oracleNetSuite')
		})
		const genericWebServiceLabel = iconAndLabel({
			name: 'webservice',
			label: i18n.get('admin.importConnections.web-service.restWebService')
		})
		const model = new Connection({
			type: WEB_SERVICE,
			wsType: REST
		})
		return {
			label: i18n.get('admin.importConnections.web-service.add'),
			target: [
				BootslideMenu.targetOption(netSuiteWebServiceLabel, () => {
					new RestConnectionWizard({ model: getDefaultOracleNetSuiteConnection() }).start()
				}),
				BootslideMenu.targetOption(genericWebServiceLabel, () => {
					new RestConnectionWizard({ model }).start()
				})
			]
		}
	}

})

export default AddWsConnectionMenu

AddWsConnectionMenu.__filename__ = 'admin/connections/add-ws-connection-menu.js'
